export class ObjectHelper {
  public static isUndefinedOrNull(obj: any) {
    return obj === undefined || obj === null;
  }

  public static isUndefinedNullOrEmpty(obj: any) {
    return obj === undefined || obj === null || obj === '';
  }
}
